import { render, staticRenderFns } from "./present_check.vue?vue&type=template&id=b16324fa"
import script from "./present_check.vue?vue&type=script&lang=js"
export * from "./present_check.vue?vue&type=script&lang=js"
import style0 from "./present_check.vue?vue&type=style&index=0&id=b16324fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports